// styles.js
const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    maxWidth: '848px',
    gap: '16px',
    padding: '0 24px',
  },
  container: {
    margin: '0 auto',
    display: 'flex',
    maxWidth: '800px',
    padding: '16px 24px',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    width: '100%',
    backgroundPosition: '50% 50%',
    background: 'var(--mcg-bg, #FFF)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    borderRadius: '16px',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    transition: 'gap 0.5s ease-in-out',
    gap: '0px',
    '&.open': {
      gap: '16px',
    },
  },
  helpIcon: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  helpText: {
    color: 'var(--mcg-dark, #002E47)',
    fontSize: '14px',
    fontWeight: 400,
    width: '100px',
    fontFamily: 'Inter',
    lineHeight: '150%' /* 21px */,
  },
  helpContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    '&:hover': {
      cursor: 'pointer',
    },
    '@media (max-width: 630px)': {
      paddingLeft: '8px !important',
    },
  },
  title: {
    fontSize: '16px',
    fontWeight: 500,
    fontFamily: 'Inter',
  },
  itemWrapper: {
    maxHeight: 0,
    transition: 'max-height 0.5s ease-in-out',
    overflow: 'hidden',
    '&.open': {
      maxHeight: '1000px',
    },
    alignItems: 'center',
    gap: '24px',
    alignSelf: 'stretch',
    display: 'grid',
    gridTemplateColumns: '1fr',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
    [theme.breakpoints.up('xl')]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
  },
  itemContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '110px',
    border: '1px solid #CBD0D7',
    borderRadius: '8px',
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    flexDirection: 'column',
    gap: '8px',
    transition: 'all 0.5s ease-in-out',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#E3F3FF',
      '& $icon': {
        color: '#002E47',
      },
      '& $text': {
        color: '#002E47',
      },
    },
  },
  itemSelected: {
    backgroundColor: '#E3F3FF',
    border: '1px solid #015FFB',
    '& $icon': {
      color: '#002E47',
    },
    '& $text': {
      color: '#002E47',
    },
  },
  icon: {
    color: 'var(--mcg-dark, #002E47)',
    fontSize: '24px',
  },
  text: {
    fontSize: '14px',
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    textAlign: 'center',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%',
  },
  headerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    width: '100%',
    '@media (max-width: 630px)': {
      paddingLeft: '8px',
    },
  },
  icons: {
    color: 'var(--mcg-dark, #002E47)',
    // Your existing icon styles here
  },
  pageTitle: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%',
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '@media (max-width: 630px)': {
      display: 'grid',
    },
  },
  changeCompletionButton: {
    color: '#fff',
    backgroundColor: 'transparent',
    width: '185px',
    height: '24px',
    gap: '8px',
    '@media (max-width: 1280px)': {
      width: '100%',
    },
    '& .MuiButton-label': {
      // This targets the internal wrapper of MUI Button
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'left',
      gap: '8px',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
  },
  buttonText: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },
})

export default styles
